import { useParams } from "react-router";
import useHeaderChange from "@/hooks/useHeaderChange";
import NoDataMessage from "@/components/NoDataMessage";
import withDisclaimer from "@/hoc/withDisclaimer";
import BalanceSheetSkeleton from "../balance-sheet/BalanceSheetSkeleton";
import Assets from "../balance-sheet/Assets";
import { useBalanceSheet } from "@/hooks/useBalanceSheet";

function NonAssetBalanceSheet() {
  const { id } = useParams();
  const { household, upLoading } = useHeaderChange(id!, "Non-Asset Balance Sheet");
  const { data, isLoading, isError, isRefetching } = useBalanceSheet(id!, true);

  if (isLoading || isRefetching || upLoading) return <BalanceSheetSkeleton />;
  if (isError) return <div>Failed fetching Non-Asset Balance Sheet</div>;

  if (!data?.data?.assets?.length) return <NoDataMessage />;

  return (
    <div
      style={{ WebkitPrintColorAdjust: "exact" }}
      id="balance-sheet"
      className="print-zoom-85 break-before-column"
    >
      <div className="flex flex-col gap-8">
        <Assets
          assetGroups={data?.data?.assets}
          household={household}
          isNonAssetBal
          layout={data?.data?.layout}
        />
      </div>
    </div>
  );
}
export default withDisclaimer(NonAssetBalanceSheet);
